module.exports = __webpack_public_path__ + "img/cielorrasos.2f02c12c.jpg";